import React from 'react';
import { Link } from 'react-router-dom';

export default function Error() {
    return (
        <div>
            <h3>Error when loading page</h3>
            <Link to="/">Return to dashboard</Link>
        </div>
    )
}
